<div
  class="loader progress"
  aria-busy="true"
  aria-valuemin="0"
  aria-valuemax="100"
  role="progressbar"
  tabindex="0"
></div>
